
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
var ReservationInformation;
import '../css/new-reservation-complete.css';
var searchbarGlobal;
import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
var customers = [];
export default {
  data: function () {
    return {
      ReservationDetails: {},
      ReservationInformation: {},
      Name: {},
      loginobject: actions.LoginGetResult(),
      ResponseGetMonthlyResData: {},
      customers: []
    };
  },

  beforeDestroy() {
    var self = this;
  },

  methods: {
    setCustomer(customerID) {
      const customer = customers.find(customer => customer.CustomerID === customerID);
      const cleanedPhone = customer?.Phone.replace(/\s/g, ''); // Remove whitespace

      const modifiedCustomer = { ...customer,
        Phone: cleanedPhone
      };
      actions.setCustomerSearch(modifiedCustomer);
      this.$f7router.navigate('/new-reservation-staydetails/', {
        transition: 'f7-parallax'
      });
    }

  },
  on: {
    pageBeforeInit: function (e, page) {},
    pageInit: function (e, page) {
      var self = this;
      var loginobject = actions.LoginGetResult();
      actions.resetCustomerSearch();
      searchbarGlobal = app.f7.searchbar.create({
        el: '.searchbarRes',
        customSearch: 'true',
        on: {
          search: function (sb, query, previousQuery) {
            if (query.length >= 2) {
              window.clearTimeout(window.timeOutId);
              window.timeOutId = window.setTimeout(function () {
                var obj = {
                  PropertyID: loginobject.PropertyID,
                  UserID: loginobject.UserID,
                  query: query
                };
                app.f7.preloader.show();
                var results = [];
                let response = app.f7.request.promise.postJSON(URLS.SearchForCustomer, {
                  obj
                }).then(res => {
                  app.f7.preloader.hide();
                  customers = res.data;
                  self.$setState({
                    SearchResult: res.data,
                    customers: res.data
                  });
                });
              }, 900);
            }
          },
          enable: function () {
            console.log('searchbarRes enabled !!');
          }
        }
      });
      searchbarGlobal.toggle();
    },

    pageBeforeRemove() {}

  },
  id: '6336b1a411',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page maincontaint" data-name=new-reservation-home><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'searchresult', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=subnavbar><form class="searchbar searchbarRes"><div class=searchbar-inner><div class=searchbar-input-wrap><input type=search placeholder=Search> <i class=searchbar-icon></i> <span class=input-clear-button></span></div></div></form></div></div></div><div class="page-content reservationspage"><div class=searchbar-backdrop></div><div class="block searchbar-hide-on-search"><p>Search with Customer name or Email</p></div><div class=list><ul class=rescard style=padding-left:0px;>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.SearchResult, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="card reservationcardbtn"><div class="card-content card-content-padding"><li class=item-content style="display: block;padding-top: 5px;padding-bottom: 5px;" @click=setCustomer(';
          r += c(ctx_2.CustomerID, ctx_2);
          r += ')><div class=row><div class=col-100 style=font-weight:600;>Name: ';
          r += c(ctx_2.FirstName, ctx_2);
          r += ' ';
          r += c(ctx_2.LastName, ctx_2);
          r += '</div><div class=col-100>Email: ';
          r += c(ctx_2.Email, ctx_2);
          r += '</div><div class=col-100>Phone: ';
          r += c(ctx_2.Phone, ctx_2);
          r += '</div><div class=col-100>Country:';
          r += c(ctx_2.Country, ctx_2);
          r += '</div></div></li></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .totalpriceroom {
        color: black;
    }
`,
  styleScoped: false
};
    